import { useEffect, useState, useRef } from "react";
import { api, API } from "@/lib/api";
import { PageTitle, Card, GBtn, Field, inputCls } from "./ui";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { Upload, Save, FileCheck2, FileX2 } from "lucide-react";

function ResourceRow({ res, reload }) {
  const [r, setR] = useState(res);
  const fileRef = useRef();
  const save = async () => { await api.put(`/admin/resources/${r.id}`, r); toast.success("Saved"); reload(); };
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try { await api.post(`/admin/resources/${r.id}/upload`, fd); toast.success("PDF uploaded"); reload(); }
    catch { toast.error("Upload failed"); }
  };
  return (
    <Card className="space-y-3">
      <Field label="Title"><input value={r.title} onChange={(e) => setR({ ...r, title: e.target.value })} className={inputCls} /></Field>
      <Field label="Description"><textarea rows={2} value={r.description} onChange={(e) => setR({ ...r, description: e.target.value })} className={inputCls} /></Field>
      <div className="flex items-center gap-6">
        <label className="flex items-center gap-2 text-sm"><Switch checked={!!r.active} onCheckedChange={(v) => setR({ ...r, active: v })} /> Active</label>
        <span className={`flex items-center gap-1.5 text-xs ${r.pdf_path ? "text-emerald-400" : "text-amber-400"}`}>
          {r.pdf_path ? <><FileCheck2 size={14} /> PDF uploaded</> : <><FileX2 size={14} /> No PDF yet</>}
        </span>
      </div>
      <input ref={fileRef} type="file" accept="application/pdf" className="hidden" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} />
      <div className="flex gap-2">
        <GBtn onClick={save}><Save size={15} /> Save</GBtn>
        <GBtn variant="ghost" onClick={() => fileRef.current.click()} data-testid={`resource-upload-${r.slug}`}><Upload size={15} /> {r.pdf_path ? "Replace PDF" : "Upload PDF"}</GBtn>
        {r.pdf_path && <a href={`${API}/resources/${r.slug}/download`} target="_blank" rel="noreferrer" className="text-xs text-[#D4AF37] self-center">View</a>}
      </div>
    </Card>
  );
}

export default function ResourcesAdmin() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/resources").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);
  return (
    <>
      <PageTitle title="Free Resources" subtitle="Upload and manage the downloadable PDFs" />
      <div className="grid lg:grid-cols-2 gap-4">
        {items.map((r) => <ResourceRow key={r.id} res={r} reload={load} />)}
      </div>
    </>
  );
}
